import createAPI from './create-api';
const cooperateApi = createAPI(process.env.MUJI_APP_API_COOPERATE);
// 查询我的发布
function fetchMyDeploy(bqueryMyPublish, page, pageSize, publishStartTime) {
    return cooperateApi.postJson('/publish/getPage', {
        bqueryMyPublish,
        page,
        pageSize,
        publishStartTime,
    });
}
// 查询我的待办
function fetchMyTodo() {
    return cooperateApi.getJson(`/todolist/get`);
}
const envApi = createAPI(process.env.MUJI_APP_API_ENV);
// 查询我的环境
function fetchMyEnv(payload) {
    return envApi.getJson('/management/myList', payload);
}
const applicationApi = createAPI(process.env.MUJI_APP_API_APPLICATION);
// 查询我的应用
function fetchMyApp({ pageIndex, pageSize, userId, appStatus, appType, isLibrary, }) {
    return applicationApi.getJson('/application/list', Object.assign({ userId, page: pageIndex, pageSize }, (appStatus ? { appStatus } : null), (appType ? { appType } : null), (isLibrary ? { isLibrary } : null)));
}
const workbenchApi = createAPI(process.env.MUJI_APP_API_WORKBENCH);
function fetchFlowList() {
    return workbenchApi.getJson(`definition/list`);
}
const dashboardApi = {
    fetchMyDeploy,
    fetchMyEnv,
    fetchMyApp,
    fetchMyTodo,
    fetchFlowList,
};
export default dashboardApi;
